<div class="row active_store mx-0" id="LocationDivContainer">

    <div class="col-md-5 p-0 active_store_lft" style="min-height: 420px;">

        <ejs-grid #gridAlldata [dataSource]='AllDataDisplay' [gridLines]='lines' height='420'
            class="table-striped  Section_Switch_Table">
            <e-columns>
                <e-column textAlign='center' type="checkbox" [allowFiltering]='false' [allowSorting]='false' width='50'>
                </e-column>
                <e-column field='Name' width='350' headerText='' textAlign='Left' i18n>
                    <ng-template #headerTemplate>
                        {{AllDataHeader}}
                        <!-- <span #AllFilterIcon class="e-icons e-icon-filter " *ngIf="(AllData.length > 0)||(isFilterAll)"
                            (click)="openAllFilterModal()"></span> -->
                    </ng-template>
                </e-column>
                <!-- <e-column field='LastExportDate' headerText=''  width='50' textAlign='Left' i18n>
                    <ng-template #headerTemplate>
                        {{exportDateHeader}}
                    </ng-template>
                </e-column> -->
            </e-columns>
        </ejs-grid>

    </div>
    <div class="col-md-2 position-relative">
        <div class="arrowsContainer">
            <img class="arrowRight" src="../../../assets/images/ArrowRight.svg" (click)="addToActiveGrid()">
            <br>
            <img class="arrowLeft" src="../../../assets/images/ArrowLeft.svg" (click)="addToAllGrid()">
        </div>
    </div>
    <div class="col-md-5 p-0 active_store_rgt" style="min-height: 420px;">

        <ejs-grid #gridActiveData [dataSource]='ActiveDataDisplay' [gridLines]='lines' height='420'
            class="table-striped Section_Switch_Table">
            <e-columns>
                <e-column textAlign='center' type="checkbox" [allowFiltering]='false' [allowSorting]='false' width='50'>
                </e-column>
                <e-column field='Name' width='350' textAlign='Left' i18n>
                    <ng-template #headerTemplate>
                        <!-- <span #ActiveFilterIcon class="e-icons e-icon-filter"
                            *ngIf="(ActiveData.length > 0)||(isFilterActive)" (click)="openActiveFilterModal()"></span> -->
                        <!-- <span #ActiveFilterIcon class="e-icons e-icon-filter"
                             (click)="RefreshActive()"></span> -->
                        {{ActiveHeader}}
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>
    </div>

</div>